import { useUserInfoStore } from "@/stores/userInfoStore";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from) => {
	document.title = to.meta.title || "Operator Platform";
	const { userInfo, getUserInfo } = useUserInfoStore();
	// 不需要登录的页面
	if (["Login", "ResetPassword", "Register"].includes(to.name)) return true;
	// 登录验证
	if (!Object.keys(userInfo || {}).length) {
		const res = await getUserInfo();
		if (res?.result) return true;
		return { name: "Login" };
	}
	// 正常跳转
	return true;
});

/*
 *上线打包的自动化工具会把上一个版本的资源文件清空，vite打包发版后，
 *当前页面缓存的还是发版之前的资源，未主动刷新成新资源，导致点击页面路由跳转页面时在服务器上找不到之前的包，
 *从而在页面上面显示为 点击切换菜单路由，页面没有任何变化，F12打开控制台发现报错
 */
 router.onError(error => {
	if (error.message.includes("Failed to fetch dynamically imported module")) {
		window.location.reload();
	}
});

export default router;
